import '../App.css';
import theme from "../Components/theme";
import Header from "../Components/Header";
import Footer from "../Components/footer";
import React, {useEffect, useState} from 'react';
import { DoubleOrbit } from 'react-spinner-animated';
import 'react-spinner-animated/dist/index.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Box, Button, CssBaseline, Grid, Typography } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

export default function SpaceReport(){
    const [aritcles, setAritcles] = useState([]);
    const [dateSpecificAritcles, setDateSpecificAritcles] = useState([]);
    const [pageNumber, setPageNumber] = useState(10);

    useEffect(() => {
        makeRequest();
    }, []);


    async function makeRequest () {
        axios.request(`https://fathomless-wave-33104.herokuapp.com/Space_Reports/`, {params : {"limit" : pageNumber}})
        .then((response) => {setAritcles(response.data)})
        .catch((error) => console.error(error));
        setPageNumber(pageNumber + 10);
    }

    const getSpecificReport = (e) => {
        if (e.target.value === ""){
            setDateSpecificAritcles([]);
        }else{
            let dateAfter = new Date(e.target.value);
            dateAfter.setDate(dateAfter.getDate() + 1);
            axios.request(`https://fathomless-wave-33104.herokuapp.com/Specific_space_Reports/`, {params : {"publishedAt" : (dateAfter.toISOString().replace(/T.*/,'').split('-').join('-'))}})
            .then((response) => {
                response.data.length <= 0 ? (setDateSpecificAritcles("no data")):(setDateSpecificAritcles(response.data))
            })
            .catch((error) => console.error(error));
        }
    };

    const getdate = (data) => {
        return{
            date : data.split("T")[0],
            time : data.split("T")[1].split(".")[0]
        }
    };

    const processedData = () => {
        return (<Box>
            <Grid container direction="column" justifyContent="center" alignItems="center" p={2} paddingTop = {"0"}>{
                aritcles.map(aritcle => {
                return(<Grid item = {true} style={classes.gridItem} key = {aritcle.id} p={2}>
                    <Link to="/Individual_Space_Report" state={{ reportInformation: aritcle }} className= {"Link"}>
                        <Box mr={1}>
                            <Typography variant="h4" fontSize={{xl: 30, lg: 30, md: 25, sm: 20, xs: 15}} fontWeight={800} style={classes.title}>{aritcle.title.split("–")[0]}</Typography>
                            <Typography variant="body1" fontSize={{xl: 25, lg: 25, md: 20, sm: 17, xs: 13}} style={classes.summery}>{aritcle.summary? (aritcle.summary) : ("No Summery")}</Typography>
                        </Box>
                        <Box>
                            <Box mt={2} mb={2}>
                                <Typography variant="body2" fontSize={{xl: 20, lg: 17, md: 14, sm: 14, xs: 11}}  style={classes.summery}>Published:</Typography>
                                <Typography variant="body2" fontSize={{xl: 20, lg: 17, md: 14, sm: 14, xs: 11}} fontWeight={800} style={classes.date} lineHeight = {3}>{getdate(aritcle.publishedAt).date}</Typography>
                            </Box>
                        </Box>
                    </Link>
                </Grid>)
            })}</Grid>
            <Box textAlign='center' >
                <Button variant='outlined' align onClick={() => makeRequest()}><Typography variant="h6" fontSize={{xl: 30, lg: 25, md: 20, sm: 17, xs: 13}}>More</Typography></Button>
            </Box>
        </Box>)
    };

    const searchResults = () => {
        const datePicker = document.getElementById("datePicker") != null? (new Date(document.getElementById("datePicker").value)) : (console.log("date not initialized yet"));
        if (dateSpecificAritcles === "no data"){
            return <Box display= "flex" justifyContent= "center">
                <Typography variant='h2' color={"white"} marginTop={"25vh"} textAlign="center" fontSize={{xl: 80, lg: 60, md: 60, sm: 60, xs: 35}}>No Reports Found</Typography>
            </Box>
        }else{
            if (getdate(dateSpecificAritcles[0].publishedAt).date === datePicker.toISOString().replace(/T.*/,'').split('-').join('-')){
                return(
                    <Grid container direction="column" justifyContent="center" alignItems="center" p={2} paddingTop = {"0"}>{
                        <Grid item = {true} style={classes.gridItem} key = {dateSpecificAritcles[0].id} p={2}>
                            <Link to="/Individual_Space_Report" state={{ reportInformation: dateSpecificAritcles[0] }} className= {"Link"}>
                                <Box mr={1}>
                                    <Typography variant="h4" fontSize={{xl: 30, lg: 30, md: 25, sm: 20, xs: 15}} fontWeight={800} style={classes.title}>{dateSpecificAritcles[0].title.split("–")[0]}</Typography>
                                    <Typography variant="body1" fontSize={{xl: 25, lg: 25, md: 20, sm: 17, xs: 13}} style={classes.summery}>{dateSpecificAritcles[0].summary? (dateSpecificAritcles[0].summary) : ("No Summery")}</Typography>
                                </Box>
                                <Box>
                                    <Box mt={2} mb={2}>
                                        <Typography variant="body2" fontSize={{xl: 20, lg: 17, md: 14, sm: 14, xs: 11}}  style={classes.summery}>Published:</Typography>
                                        <Typography variant="body2" fontSize={{xl: 20, lg: 17, md: 14, sm: 14, xs: 11}} fontWeight={800} style={classes.date} lineHeight = {3}>{getdate(dateSpecificAritcles[0].publishedAt).date}</Typography>
                                    </Box>
                                </Box>
                            </Link>
                        </Grid>
                    }</Grid>
                )
            }else{
                return (
                    <Box>
                        <Box p={2} paddingBottom={0}>
                            <Typography variant="h2" fontSize={{xl: 25, lg: 25, md: 20, sm: 20, xs: 15}}  style={classes.summery}>The specific date was not found. Here are some articles around that time</Typography>
                        </Box>
                        <Grid container direction="column" justifyContent="center" alignItems="center" p={2} paddingTop = {"0"}>{
                            dateSpecificAritcles.map(aritcle => {
                            return(<Grid item = {true} style={classes.gridItem} key = {aritcle.id} p={2}>
                                <Link to="/Individual_Space_Report" state={{ reportInformation: aritcle }} className= {"Link"}>
                                    <Box mr={1}>
                                        <Typography variant="h4" fontSize={{xl: 30, lg: 30, md: 25, sm: 20, xs: 15}} fontWeight={800} style={classes.title}>{aritcle.title.split("–")[0]}</Typography>
                                        <Typography variant="body1" fontSize={{xl: 25, lg: 25, md: 20, sm: 17, xs: 13}} style={classes.summery}>{aritcle.summary? (aritcle.summary) : ("No Summery")}</Typography>
                                    </Box>
                                    <Box>
                                        <Box mt={2} mb={2}>
                                            <Typography variant="body2" fontSize={{xl: 20, lg: 17, md: 14, sm: 14, xs: 11}}  style={classes.summery}>Published:</Typography>
                                            <Typography variant="body2" fontSize={{xl: 20, lg: 17, md: 14, sm: 14, xs: 11}} fontWeight={800} style={classes.date} lineHeight = {3}>{getdate(aritcle.publishedAt).date}</Typography>
                                        </Box>
                                    </Box>
                                </Link>
                            </Grid>)
                        })}</Grid>
                    </Box>
                )
            }
        }
    }

    const classes ={
        title:{
            marginBottom: ".5em",
            
        },

        summery : {
            color : "white",
            display: 'inline',
            lineHeight: "100%",
        },

        date:{
            display: 'inline',
            marginLeft:"2%"
        },

        gridItem:{
            border: `.1em solid ${theme.palette.primary.main}`,
            borderRadius: "1em",
            marginTop: "1.5em",
        },
        
        main:{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            marginBottom: "10vh",
            padding: "0"
        },

        datePicker:{
            background: "none",
            color : theme.palette.primary.main,
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: `.1em solid white`,
            fontSize: "clamp(1.2rem, 2.5vw, 2rem)",
            outline: "none",
        },
      };

    return(<ThemeProvider theme={theme}>
        <CssBaseline />
            {aritcles.length > 0 ? (<Box>
            <Box style={classes.main}>
                <Header/>
                <Box p={2} fontSize={{xl: 40, lg: 35, md: 30, sm: 25, xs: 20}}>
                    <input type="date" id={"datePicker"} max={getdate(aritcles[0].publishedAt).date} style={classes.datePicker} onChange={getSpecificReport} placeholder={getdate(aritcles[0].publishedAt).date}/>
                </Box>
                {dateSpecificAritcles.length > 0  ? (searchResults()) : (processedData())}
            </Box>
            <Box textAlign='center'>
                <Footer/>
            </Box>
        </Box>):(<DoubleOrbit center={true} text={"Loading"}/>)}
        
    </ThemeProvider>)
};